/**
 * The HubSpot Meetings page every "Book a demo" control leads to.
 *
 * A plain module, not part of `book-meeting-modal.tsx`: that file is
 * `'use client'`, so importing a constant from it into a server action gives a
 * client reference, not a string. The blog's CTA block spec bakes this URL into
 * published HTML from the bake server action, and the modal embeds it, so both
 * import it from here.
 */
export const MEETINGS_PAGE_URL = 'https://home.schooljourney.com/meetings/jgiblett/school-journey-app-demo-jamie'

/** Jamie's launch planning and admin training call, for schools getting ready to welcome families. */
export const LAUNCH_PLANNING_URL = 'https://home.schooljourney.com/meetings/jgiblett/app-training-launch-planning'
